export default __webpack_public_path__ + "static/media/LVT.951e1294.png";